<template>
    <select-input
      class="lg:max-w-xs lg:inline-block"
      v-model="filters.specialty">
        <option value="" selected>Especialidade</option>
        <option
          v-for="( specialty, index ) in specialtys"
          :key="index"
          :value="specialty.id">
            {{ specialty.name }}
        </option>
    </select-input>

    <date-month-input
      class="mt-4 lg:max-w-xs lg:inline-block lg:ml-4"
      :clearable="false"
      placeholder="Mês"
      v-model="filters.date" />

    <radio-input-group
      class="mt-4 lg:inline-block lg:ml-4"
      :options="optionsRadio"
      label="Filtrar por:"
      name="filterby"
      v-model="filters.filterby" />

    <data-table
      v-if="loadTable"
      class="mt-10"
      v-model:columns="columns"
      :route="`/payments/list?${ getFilters }`"
      no-data-label="Nenhum agendamento cadastrado"
      no-result-label="Nenhum agendamento encontrado">
        <template #table.cell.content.patient="{ value, row }">
          <button
            type="button"
            class="text-primary underline"
            @click="$emit( 'viewPatient', row.patient.id )">
              {{ value }}
          </button>
        </template>

      <template #table.cell.content.status="{ value, row }">
        <Popover>
          <template #default>
      <span class="text-primary font-semibold cursor-pointer">
        {{ statusAppointment[value]?.label ?? 'Status desconhecido' }}
      </span>
          </template>

          <template #dropdown>
            <div class="p-4 bg-white shadow_box rounded-lg text-xs">
              <div class="flex flex-nowrap">
                {{ statusAppointment[value]?.description ?? 'Sem descrição disponível' }}
              </div>
            </div>
          </template>
        </Popover>
      </template>

      <!--        <template #table.cell.content.status="{ value, row }">-->
<!--          <Popover>-->
<!--            <template #default>-->
<!--              <span class="text-primary font-semibold cursor-pointer">-->
<!--                {{ statusAppointment[value].label }}-->
<!--              </span>-->
<!--            </template>-->

<!--            <template #dropdown>-->
<!--              <div class="p-4 bg-white shadow_box rounded-lg text-xs">-->
<!--                <div class="flex flex-nowrap">-->
<!--                  {{ statusAppointment[value].description }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </Popover>-->
<!--        </template>-->
    </data-table>

</template>

<script>

import DataTable from '@/Shared/Components/DataTable'
import SelectInput from '@/Shared/Fields/SelectInput'
import DateMonthInput from '@/Shared/Fields/DateMonthInput'
import RadioInputGroup from '@/Shared/Fields/RadioInputGroup.vue'
import Popover from '@/Shared/Components/Popover'



const optionsRadio = [
  {
    label: 'Consultas ativas',
    value: 'active',
  },
  {
    label: 'Consultas canceladas',
    value: 'cencelled',
  },
]



const statusAppointment = {
  active: {
    label: 'Ativo',
    description: 'A consulta está ativa',
  },
  completed: {
    label: 'Completa',
    description: 'A consulta foi concluída',
  },
  cancelled: {
    label: 'Cancelado',
    description: 'A consulta não foi paga no prazo',
  },
  cancelled_professional: {
    label: 'Cancelado',
    description: 'Cancelada pelo profissional',
  },
  cancelled_patient: {
    label: 'Cancelado',
    description: 'Cancelada pelo paciente',
  },
}


const columns = [
  {
    uniqid: 'date_start',
    label: 'Data da Consulta',
    field: 'date_start',
    visible: true,
    sortable: true,
    sortOrder: 'asc',
    classes: 'px-4 py-3 border-b text-sm',
    headerClass: 'p-4 text-left',
    format: (val) => {
      if (!val) return 'Não informado'
      return val.split(' ')[0]?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1') || 'Não informado'
    }
  },
  {
    uniqid: 'patient',
    label: 'Paciente',
    field: 'patient',
    visible: true,
    sortable: true,
    sortOrder: 'asc',
    classes: 'px-4 py-3 border-b text-sm whitespace-nowrap max-w-[200px] overflow-hidden text-ellipsis',
    headerClass: 'p-4 text-left',
    format: (val) => val?.user?.name || 'Não informado'
  },
  {
    uniqid: 'specialty',
    label: 'Especilidade',
    field: 'specialty',
    visible: true,
    sortable: true,
    sortOrder: 'asc',
    classes: 'px-4 py-3 border-b text-sm',
    headerClass: 'p-4 text-left',
    format: (val) => val?.name || 'Não informado',
  },
  {
    uniqid: 'segment',
    label: 'Segmento',
    field: 'patient.b2b',
    visible: true,
    sortable: false,
    sortOrder: 'asc',
    classes: 'px-4 py-3 border-b text-sm text-center',
    headerClass: 'p-4 text-left',
    format: (val, row) => {
      if (row.patient?.b2b === true) return 'B2B'
      if (row.patient?.b2b === false) return 'B2C'
      return 'Não informado'
    }
  },
  {
    uniqid: 'hour',
    label: 'Horário',
    field: 'hour',
    visible: true,
    sortable: true,
    sortOrder: 'asc',
    classes: 'px-4 py-3 border-b text-sm',
    headerClass: 'p-4 text-left',
    format: (val, row) => {
      if (!row.date_start || !row.date_end) return 'Não informado'
      try {
        const dateStart = new Date(row.date_start)
        const dateEnd = new Date(row.date_end)

        const hoursStart = dateStart.getHours().toString().padStart(2, '0')
        const minuteStart = dateStart.getMinutes().toString().padStart(2, '0')
        const hoursEnd = dateEnd.getHours().toString().padStart(2, '0')
        const minuteEnd = dateEnd.getMinutes().toString().padStart(2, '0')

        return `${hoursStart}:${minuteStart}-${hoursEnd}:${minuteEnd}`
      } catch {
        return 'Não informado'
      }
    }
  },
  {
    uniqid: 'status',
    label: 'Status da Consulta',
    field: 'status',
    classes: 'px-4 py-3 border-b text-sm',
    headerClass: 'p-4 text-left',
    format: (val) => val || 'Não informado',
  },
  {
    uniqid: 'consultation_price',
    label: 'Valor da Consulta',
    field: 'consultation_price',
    visible: true,
    sortable: true,
    sortOrder: 'asc',
    classes: 'px-4 py-3 border-b text-sm text-center',
    headerClass: 'p-4 text-left',
    format: (val, row) => {
      if (row.patient?.b2b === true) return 'N/A'

      const isEmpty = val === null || val === undefined || val === '' || parseFloat(val) === 0
      return isEmpty ? 'Não informado' : val
    }
  },

]



export default {

  components: {
    DataTable,
    SelectInput,
    DateMonthInput,
    RadioInputGroup,
    Popover,
  },

  emits: [ 'viewPatient' ],

  props: {
    professionalId: {
      type: String,
      required: true,
    },

    specialtys: {
      type: Array,
      required: true,
    }
  },

  data() {
    return {
      loadTable: true,

      filters: {
        id: this.$props.professionalId,
        specialty: '',
        date: '',
        filterby: '',
      },

    }
  },

  watch: {
    filters: {
      handler() {
        this.reloadTable()
      },
      deep: true,
    },
  },

  computed: {
    getFilters() {
      return Object.entries(this.filters).map(([key, value]) => `${key}=${value}`).join('&')
    }
  },

  methods: {
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
  },

  setup() {
    return { columns, optionsRadio, statusAppointment }
  }
}



</script>
